import React from "react";
import numeral from "numeral";
import styles from "./style.module.css";

const ExpandedToolTip = (props) => {
  const { data, tooltipLabel, baselinesEnabled } = props;

  const tooltipRow = { display: "flex", marginTop: "10px", height: "20px" };

  const optimized = data.find((subset) => subset.id === "optimized");
  const current = data.find((subset) => subset.id === "current");
  const baseline = data.find((subset) => subset.id === "baseline");

  const optimizedCost = optimized && optimized.Cost;
  const currentCost = current && current.Cost;
  const baselineCost = baseline && baseline.Cost;
  const optimizedImprovement = optimizedCost && currentCost && optimizedCost - currentCost;

  const determineChart = () => {
    const sameSigns = Math.sign(optimizedCost) === Math.sign(currentCost);
    const positioningPayload = {};
    let maxWidth = Math.max(Math.abs(optimizedCost), Math.abs(currentCost), Math.abs(baselineCost));
    if (sameSigns) {
      positioningPayload.optimizedWidth = Math.abs((optimizedCost / maxWidth) * 100);
      positioningPayload.currentWidth = Math.abs((currentCost / maxWidth) * 100);
      positioningPayload.baselineWidth = Math.abs((baselineCost / maxWidth) * 100);
      positioningPayload.diffBarWidth = Math.abs((optimizedImprovement / maxWidth) * 100);
      positioningPayload.diffBarPosition = optimizedCost > 0 ? 100 - positioningPayload.diffBarWidth : 0;
      positioningPayload.optimizedBarPosition = optimizedCost < 0 ? 100 - positioningPayload.optimizedWidth : 0;
      positioningPayload.currentBarPosition = optimizedCost < 0 ? 100 - positioningPayload.currentWidth : 0;
      positioningPayload.baselineBarPosition = optimizedCost < 0 ? 100 - positioningPayload.baselineWidth : 0;
    } else {
      let maxWidth = Math.max(Math.abs(optimizedCost), Math.abs(currentCost), Math.abs(optimizedImprovement));
      positioningPayload.optimizedWidth = Math.min(Math.abs((optimizedCost / maxWidth) * 100), 50);
      positioningPayload.optimizedBarPosition = optimizedCost >= 0 ? 50 : 50 - positioningPayload.optimizedWidth;
      positioningPayload.currentWidth = Math.abs((currentCost / maxWidth) * 100);
      positioningPayload.currentBarPosition = currentCost >= 0 ? 50 : 50 - positioningPayload.currentWidth;
      positioningPayload.baselineWidth = Math.abs((baselineCost / maxWidth) * 100);
      positioningPayload.baselineBarPosition = baselineCost >= 0 ? 50 : 50 - positioningPayload.baselineWidth;
      positioningPayload.diffBarWidth = Math.abs((optimizedImprovement / maxWidth) * 100);
      positioningPayload.diffBarPosition = 0;
    }

    return positioningPayload;
  };

  const barPayload = determineChart();

  return (
    <div className={styles.extendedToolTipContainer}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ fontSize: "16px" }}>
          <strong>
            Scenario {tooltipLabel}: $ {numeral(optimizedCost).format("0.0a")}
          </strong>
        </div>
        <div style={tooltipRow}>
          <div className={styles.extendedTTLabel}>Optimized</div>
          <div className={styles.extendedTTBar}>
            <div
              style={{
                backgroundColor: "#7E69D7",
                borderRadius: "12px",
                height: "60%",
                width: barPayload.optimizedWidth + "%",
                marginLeft: barPayload.optimizedBarPosition + "%"
              }}
            ></div>
          </div>
          <div className={styles.extendedTTValue}>{"$ " + numeral(optimizedCost).format("0.0a")}</div>
        </div>
        <div style={tooltipRow}>
          <div className={styles.extendedTTLabel}>Improvement</div>
          <div className={styles.extendedTTBar}>
            <div
              style={{
                backgroundColor: "#5BCF74",
                borderRadius: "12px",
                height: "40%",
                width: barPayload.diffBarWidth + "%",
                marginLeft: barPayload.diffBarPosition + "%"
              }}
            ></div>
          </div>
          <div className={styles.extendedTTValue}>{"$ " + numeral(optimizedImprovement).format("0.0a")}</div>
        </div>
        <div style={tooltipRow}>
          <div className={styles.extendedTTLabel}>Current</div>
          <div className={styles.extendedTTBar}>
            <div
              style={{
                backgroundColor: "#C8CAD4",
                borderRadius: "12px",
                height: "40%",
                width: barPayload.currentWidth + "%",
                marginLeft: barPayload.currentBarPosition + "%"
              }}
            ></div>
          </div>
          <div className={styles.extendedTTValue}>{"$ " + numeral(currentCost).format("0.0a")}</div>
        </div>
        <div style={tooltipRow}>
          <div className={styles.extendedTTLabel}>Baseline</div>
          {baselinesEnabled ? (
            <React.Fragment>
              <div className={styles.extendedTTBar}>
                <div
                  style={{
                    backgroundColor: "#512F77",
                    borderRadius: "12px",
                    height: "40%",
                    width: barPayload.baselineWidth + "%",
                    marginLeft: barPayload.baselineBarPosition + "%"
                  }}
                ></div>
              </div>
              <div className={styles.extendedTTValue}>{"$ " + numeral(baselineCost).format("0.0a")}</div>
            </React.Fragment>
          ) : (
            <div
              style={{
                width: "70%",
                display: "flex",
                alignItems: "center",
                fontWeight: "bold"
              }}
            >
              Baseline Scenario Not Enabled
            </div>
          )}
        </div>
        {/* <div style={tooltipRow}>
          <a>What is This?</a>
        </div> */}
      </div>
    </div>
  );
};

export default ExpandedToolTip;
